import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import HolidayApi from "../../../axios/LeaveAndHoliday/HolidayApi";

const DeleteHolidayDialog = ({ onClose, onRefresh, holidayInfo }) => {
  const { deleteHoliday } = HolidayApi();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleCloseDialog = () => {
    if (loading) return;
    onClose();
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        ...holidayInfo,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await deleteHoliday(payload);

      if (
        response?.data?.message === "Successful" ||
        response?.data?.message === "Thành công"
      ) {
        onClose();
        toast.success(t("common.delete-holiday-successfully"));
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="delete"
      title={t("common.delete-holiday")}
      subtitle={t("common.content-186")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleCloseDialog}
      onConfirm={handleSubmit}
    />
  );
};

export default DeleteHolidayDialog;
